module.exports = __webpack_public_path__ + "img/bugle.682255bf.png";